export const BallChangePolicy = [
    {
        description: 'No ball changes',
        frequency: null
    },
    {
        description: 'First change after 7 games, after that every 9 games',
        type: 'GAME',
        frequency: [7, 9]
    },
    {
        description: 'First change after 9 games, after that every 11 games',
        type: 'GAME',
        frequency: [9, 11]
    },
    {
        description: 'First change after 11 games, after that every 13 games',
        type: 'GAME',
        frequency: [11, 13]
    }, {
        description: 'Change after every set',
        type: 'SET',
        frequency: [1]
    },
    {
        description: 'Change after 2 sets',
        type: 'SET',
        frequency: [2]
    }
];
